import { createApi } from "@reduxjs/toolkit/query/react";

import { REPORTS } from "src/helpers/url";
import { baseQuery } from "src/redux/apiService";

const TAGS = {
  REPORTS: "REPORTS",
};

export const reportsApi = createApi({
  reducerPath: "reportsApi",
  baseQuery,
  tagTypes: [TAGS.REPORTS],
  endpoints: (builder) => ({
    getReports: builder.query({
      query: (params) => ({
        url: REPORTS,
        params,
      }),
      providesTags: [TAGS.REPORTS],
    }),
    refreshReport: builder.mutation({
      query: () => ({
        url: `${REPORTS}/refresh`,
        method: "POST",
      }),
      invalidatesTags: [TAGS.REPORTS],
    }),
  }),
});

export const { useGetReportsQuery, useRefreshReportMutation } = reportsApi;
